<script setup lang="ts">
import { AppEnums } from '../../shared/enums';
import { useElementSize } from '@vueuse/core';
import { AppCoreEnums } from '../shared/enums';
import useDrawer from '../composable/use-drawer';
import { DrawerInfo } from '../../stores/core/models';
import { useCoreStore } from '../../stores/core/store';
import AppSearchInput from './form/app-search-input.vue';
import AppButton from '../components/common/app-button.vue';
import { ref, watchEffect, onUnmounted, PropType } from 'vue';
//import TableBasedContainerFiltersRowsOptions from './table-based-container-filters-rows-options.vue';

const emit = defineEmits(['search-changed']);

const props = defineProps({
  containerType: {
    type: Number as PropType<AppCoreEnums.ContainerType>,
    required: true,
  },
});
const coreStore = useCoreStore();
const { showDrawer } = useDrawer();
const filtersContainerEl = ref(null);
const { height } = useElementSize(filtersContainerEl);

const setHeight = (val: number) => coreStore.setContainerFiltersHeight(props.containerType, val == 0 ? 0 : val + 4); // 4 for padding/margins

const onChooseColumns = () => {
  const info = new DrawerInfo(AppEnums.DrawerIds.SelectColumns);
  info.title = 'core.selectColumns';
  info.saveBtnLabel = 'core.save';
  info.icon = 'hugeicons:chart-column';
  info.data = props.containerType;
  showDrawer(info);
};

watchEffect(() => setHeight(height.value));
onUnmounted(() => setHeight(0));
</script>

<template>
  <div class="flex w-full items-center justify-between p-[16px] bg-gray-50 dark:bg-gray-900 rounded-xl" ref="filtersContainerEl">
    <div class="flex items-center gap-x-4">
      <!----------
      -- Search --
      ------------>
      <app-search-input :container-type="containerType" @search-changed="$emit('search-changed')" />

      <div>
        <slot name="filters"></slot>
      </div>
    </div>
    <div class="flex">
      <slot name="filters-right"></slot>
      <!------------------
      -- Choose Columns -- 
      -------------------->
      <app-button :severity="'regular'" icon="hugeicons:grid-table" label="core.columns" @click="onChooseColumns" />

    </div>
  </div>
</template>
